
<div class="confirm-dialog">
  <div class="confirm-body">
    <p class="confirm-message">{{ config.data.message }}</p>
  </div>

  <div class="dialog-actions">
    <button
      pButton
      type="button"
      label="{{'ACTION.CANCEL'|translate}}"
      class="p-button-danger custom-cancel"
      (click)="reject()"
    ></button>

    <button
      pButton
      type="button"
      label="{{'ACTION.CONFIRM_AND_SUBMIT'|translate}}"
      class="p-button-primary custom-confirm"
      (click)="accept()"
    ></button>
  </div>
</div>
